// TODO: once we can import from mi-ui-library (DXP-30678), remove this file and replace all references with '@marriott/mi-ui-library':
// ie:
// Replace:
// import { baseVariables } from '../../utils/TempMiUiLibraryUtils';
// With:
// import { baseVariables } from '@marriott/mi-ui-library';

export const baseVariables = {
  mediaQuery: {
    xl: ' screen and (min-width: 1200px)',
    lg: ' screen and (min-width: 992px)',
    md: ' screen and (min-width: 768px)',
    sm: ' screen and (min-width: 576px)',
    largeDesktop: ' (min-width:  1200px)',
    desktop: ' (min-width:  992px)',
    tablet: ' screen and (min-width:  768px)',
    allTablets: ' screen and (min-width:  768px) and (max-width: 992px)',
    mobile: ' screen and (min-width: 576px)',
    smallMobile: ' screen and (min-width: 0px)',
  },
  spacers: {
    spacers: {
      '0': 0,
      '1': '0.25rem',
      '2': '0.5rem',
      '3': '1rem',
      '4': '1.5rem',
      '5': '2rem',
      '6': '2.5rem',
      '7': '3rem',
      '8': '4rem',
      '9': '6rem',
    },
    spacer: '1rem',
  },
  shadows: {
    'white-header': '0 0.280625rem 0.8425rem 0 rgba(0, 0, 0, 0.12)',
    shadowBlur02: '0 0.375rem 0.625rem 0 rgba(0, 0, 0, 0.07)',
    shadowBlur01: '0 0.375rem 1.625rem 0 rgba(0, 0, 0, 0.07)',
    shadow04: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.5)',
    shadow03: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.5)',
    shadow02: '0 0.25 0.875rem 0 rgba(0, 0, 0, 0.5)',
    shadow01: '0 0.25rem 1.65rem 0 rgba(0, 0, 0, 0.5)',
    shadowSubtle04: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.1)',
    shadowSubtle03: '0 0.125rem 0.625rem 0 rgba(0, 0, 0, 0.3)',
    shadowSubtle02: '0 0.25rem 0.875rem 0 rgba(0, 0, 0, 0.4)',
    shadowSubtle01: '0 0.25rem 1.25rem 0 rgba(0, 0, 0, 0.08)',
    boxShadowPopover: '0rem 0.438rem 1.25rem 0rem rgba(0, 0, 0, 0.25)',
    boxShadowDeeper: '0 0.25rem 0.75rem rgb(112, 112, 112)',
    boxShadowSubsection: '0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.1)',
    boxShadowClassic: 'rgba(28, 28, 28, 0.09)',
    boxShadowSlide: 'rgba(0, 0, 0, 0.33)',
    boxShadowMenu: 'rgba(28, 28, 28, 0.09)',
    boxShadowTile: 'rgba(0, 0, 0, 0.07)',
  },
  opacity: {
    opacity7: 0.7,
    opacity6: 0.6,
    opacity5: 0.54,
    opacity4: 0.46,
    opacity3: 0.3,
    opacity2: 0.2,
    opacity1: 0.1,
  },
  gradient: {
    baseGradient11: 'linear-gradient(90deg, rgba(0, 0, 0, 0.62) 0%, rgba(0, 0, 0, 0.54) 76%, rgba(0, 0, 0, 0) 100%)',
    baseGradient10: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 34%, rgba(0, 0, 0, 0.62) 100%)',
    baseGradient07:
      'linear-gradient(270deg, rgba(0, 0, 0, 0) 37.22%, rgba(0, 0, 0, 0.54) 68.51%, rgba(0, 0, 0, 0.62) 100%)',
    baseGradient06:
      'linear-gradient(270deg, rgba(0, 0, 0, 0) 26.95%, rgba(0, 0, 0, 0.54) 67.69%, rgba(0, 0, 0, 0.62) 100%)',
    baseGradient05:
      'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 34.78%, rgba(0, 0, 0, 0.62) 100%)',
    baseGradient04: 'linear-gradient(0deg, rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0))',
    baseGradient09:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.54) 0%, rgba(255, 255, 255, 0.46) 79%, rgba(255, 255, 255, 0) 96%)',
    baseGradient08:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.54) 34%, rgba(255, 255, 255, 0.54) 100%)',
    baseGradient03:
      'linear-gradient(270deg, rgba(255, 255, 255, 0) 37.22%, rgba(255, 255, 255, 0.46) 68.51%, rgba(255, 255, 255, 0.54) 100%)',
    baseGradient02:
      'linear-gradient(270deg, rgba(255, 255, 255, 0) 26.95%, rgba(255, 255, 255, 0.46) 66.99%, rgba(255, 255, 255, 0.54) 100%)',
    baseGradient01:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.46) 34.78%, rgba(255, 255, 255, 0.54) 100%)',
    baseGradient00:
      'linear-gradient(0deg, rgba(255, 255, 255, 0.54), rgba(255, 255, 255, 0.46), rgba(255, 255, 255, 0))',
  },
  font: {
    fontStyleItalic: 'italic',
    fontWeightBold: 900,
    fontWeightMedium: 700,
    fontWeightRegular: 500,
    fontWeightLight: 400,
    lineHeight2x: '4rem',
    lineHeight1x: '2.75rem',
    lineHeightXxxl: '2.375rem',
    lineHeightXxl: '1.625rem',
    lineHeightXl: '1.5rem',
    lineHeightL: '1.375rem',
    lineHeightM: '1.25rem',
    lineHeightS: '1.125rem',
    lineHeightXs: '1rem',
    font4x: '5.625rem',
    font3x: '3.75rem',
    font2x: '2.25rem',
    font1x: '2.125rem',
    fontXxxl: '1.5rem',
    fontXxl: '1.375rem',
    fontXl: '1.30rem',
    fontL: '1.125rem',
    fontM: '1rem',
    fontS: '0.875rem',
    fontXs: '0.75rem',
    fontFamilyHe: 'Swiss721Hebrew',
    fontFamilyRu: 'UniversLTCYR',
    fontFamilySc: 'NotoSansSC',
    fontFamilyTc: 'NotoSansTC',
    fontFamilyJa: 'NotoSansJP',
    fontFamilyKo: 'NotoSansKR',
    fontFamilyAr: 'JannaLT',
    fontFamilyPl: 'UniversNextW1G,Helvetica,Arial,sans-serif',
    fontFamilyVideoicons: 'VideoIcons',
    fontPortfolioLogoIcons: 'PortfolioLogoIcons',
    fontBrandLogoIcons: 'BrandLogoIcons',
    fontMiIcons: 'MiIcons',
    fontSwissCondensed: 'SwissCondensed',
    fontSwiss: 'Swiss-721',
    fontFamilySwiss: 'Swiss-721',
  },
  border: {
    borderStyle02: 'dotted',
    borderStyleDefault: 'solid',
    borderOffset01: '2rem',
    borderInset02: '0.5rem',
    borderRadiusNone: 0,
    borderRadiusDefault: '0.875rem',
    borderRadius05: '50%',
    borderRadius04: '1.625rem',
    borderRadius03: '0.375rem',
    borderRadius02: '0.25rem',
    borderRadius01: '0.125rem',
    borderWidth05: '0.25rem',
    borderWidth04: '0.125rem',
    borderWidth03: '0.094rem',
    borderWidth02: '0.063rem',
    borderWidth01: '0.031rem',
  },
  animations: {
    easeInOut: 'cubic-bezier(0, 0, 0.67, 1)',
    easeOutSlow: 'cubic-bezier(0, 0, 0.4, 1)',
    easeInSlow: 'cubic-bezier(0.5, 0, 1, 1)',
    easeBoth01: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    durationExtended: '900ms',
    durationIntermediate: '600ms',
    durationStandard: '300ms',
    durationQuick: '100ms',
  },
  color: {
    backgroundColorNavitemHover: 'rgba(28, 28, 28, 0.25)',
    ambassadorGradientRtl: 'linear-gradient(225deg, #40332d 0, #231c19 100%)',
    titaniumGradientRtl: 'linear-gradient(225deg, #554749 0, #342829 100%)',
    platinumGradientRtl: 'linear-gradient(225deg, #5e5f61 0, #43454a 100%)',
    goldGradientRtl: 'linear-gradient(225deg, #8c6f49 0, #6f4818 100%)',
    silverGradientRtl: 'linear-gradient(225deg, #707488 0, #575b6e 100%)',
    memberGradientRtl: 'linear-gradient(224.51deg, #b94600 0, #ff9662 100%)',
    ambassadorGradient: 'linear-gradient(135deg, #40332d 0, #231c19 100%)',
    titaniumGradient: 'linear-gradient(135deg, #554749 0, #342829 100%)',
    platinumGradient: 'linear-gradient(135deg, #5e5f61 0, #43454a 100%)',
    goldGradient: 'linear-gradient(135deg, #8c6f49 0, #6f4818 100%)',
    silverGradient: 'linear-gradient(135deg, #707488 0, #575b6e 100%)',
    memberGradient: 'linear-gradient(135.49deg, #b94600 0, #ff9662 100%)',
    gradient19:
      'linear-gradient(270deg, hsla(0, 0.1%, 100%, 0) 37.22%, hsla(0, 0.1%, 100%, 0.46) 68.51%, hsla(0, 0.1%, 100%, 0.54))',
    gradient18:
      'linear-gradient(270deg, hsla(0, 0.1%, 100%, 0) 26.95%, hsla(0, 0.1%, 100%, 0.46) 66.99%, hsla(0, 0.1%, 100%, 0.54) 100%)',
    gradient17:
      'linear-gradient(180deg, hsla(0, 0.1%, 100%, 0) 0%, hsla(0, 0.1%, 100%, 0.46) 34.78%, hsla(0, 0.1%, 100%, 0.54) 100%)',
    gradient16:
      'linear-gradient(0deg, rgba(28, 28, 28, 0) 0, rgba(28, 28, 28, 0.33) 60.47%, rgba(28, 28, 28, 0.42) 100%)',
    gradient15:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.46) 49.96%, rgba(255, 255, 255, 0.54) 100%)',
    gradient14:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.54) 47.23%, rgba(255, 255, 255, 0.54) 100%)',
    gradient13:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.46) 33.67%, rgba(255, 255, 255, 0.54) 100%)',
    gradient12:
      'linear-gradient(270deg, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0.5) 54.29%, rgba(255, 255, 255, 0.7) 61%)',
    gradient11:
      'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.54) 23.21%, rgba(255, 255, 255, 0.62) 100%)',
    gradient09:
      'linear-gradient(270deg, rgba(0, 0, 0, 0) 37.22%, rgba(0, 0, 0, 0.54) 68.51%, rgba(0, 0, 0, 0.62) 100%)',
    gradient08:
      'linear-gradient(270deg, rgba(0, 0, 0, 0) 26.95%, rgba(0, 0, 0, 0.54) 67.69%, rgba(0, 0, 0, 0.62) 100%)',
    gradient07: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 34.78%, rgba(0, 0, 0, 0.62) 100%)',
    gradient06: 'linear-gradient(0deg, rgba(0, 0, 0, 0.62) 5%, rgba(0, 0, 0, 0.54) 15%, rgba(0, 0, 0, 0) 45%)',
    gradient05: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 58.94%, rgba(0, 0, 0, 0.62) 100%)',
    gradient04: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 47.23%, rgba(0, 0, 0, 0.62) 100%)',
    gradient03: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 33.67%, rgba(0, 0, 0, 0.62) 100%)',
    gradient02: 'linear-gradient(270deg, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.54) 54.29%, rgba(0, 0, 0, 0.62) 61%)',
    gradient01: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 23.21%, rgba(0, 0, 0, 0.62) 100%)',
    gradient00: 'linear-gradient(180deg, rgba(97, 96, 96, 0) 0%, rgba(0, 0, 0, 0.54) 25.52%, rgba(0, 0, 0, 0.54) 100%)',
    alert50: 'rgb(208, 2, 27)',
    alert40: 'rgb(185, 70, 0)',
    alert30: 'rgb(71, 125, 0)',
    alert20: 'rgb(196, 196, 196)',
    alert10: 'rgb(255, 255, 255)',
    ambassadorSolid: 'rgb(35, 28, 25)',
    titaniumSolid: 'rgb(85, 71, 73)',
    platinumSolid: 'rgb(94, 95, 97)',
    goldSolid: 'rgb(140, 111, 73)',
    silverSolid: 'rgb(112, 116, 136)',
    memberSolidAlt: 'rgb(248, 248, 248)',
    memberSolid: 'rgb(255, 150, 98)',
    merch70: 'rgb(240, 251, 227)',
    merch60: 'rgb(255, 185, 149)',
    merch50: 'rgb(255, 255, 255)',
    merch40: 'rgb(251, 192, 45)',
    merch30: 'rgb(28, 28, 28)',
    merch20: 'rgb(71, 125, 0)',
    merch10: 'rgb(255, 150, 98)',
    bvyAccent40: 'rgb(202, 215, 235)',
    bvyAccent30: 'rgb(255, 218, 160)',
    bvyAccent20: 'rgb(220, 111, 80)',
    bvyAccent10: 'rgb(255, 185, 149)',
    bvyBase30: 'rgb(255, 141, 107)',
    bvyBase20: 'rgb(249, 246, 244)',
    bvyBase10: 'rgb(35, 28, 25)',
    neutral40: 'rgb(112, 112, 112)',
    neutral30: 'rgb(196, 196, 196)',
    neutral20: 'rgb(238, 238, 238)',
    neutral10: 'rgb(244, 244, 244)',
    neutral00: 'rgb(0, 0, 0)',
    accent10: 'rgb(255, 141, 107)',
    base25: '255 255 255',
    base20: 'rgb(255, 255, 255)',
    base15: '28 28 28',
    base10: 'rgb(28, 28, 28)',
  },
  cnColor: {
    baiduButtonColor: '#5b89e9',
  },
};
